<div *ngIf="lineCategory.Lines.length !== 0" class="list-section-tabs">
  <div class="list-section-nav">
    <button *ngIf="this.allowAdd" class="list-section-add" nz-button nzType="default" (click)="addNewCard()">
      <i nz-icon nzType="plus" nzTheme="outline"></i> {{'Add new' | locale}}
    </button>
    <div class="list-section-line-list">
      <button
        class="list-section-line"
        [class.active]="selectedIndex === i"
        type="button"
        *ngFor="let line of lineCategory.Lines; let i = index; trackBy: trackByLineId"
        (click)="selectLine(i)">
        <span class="list-section-line-title">{{ line.Title }}</span>
        <i
          *ngIf="section.AdditionalInformationParsed.AllowDelete && this.actionType !== 'View'"
          class="list-section-line-remove"
          nz-icon
          nzType="close"
          nzTheme="outline"
          (click)="$event.stopPropagation(); deleteCard({ index: i })"></i>
      </button>
    </div>
  </div>
  <div class="list-section-content">
    <ng-container *ngFor="let selectedLine of selectedLines; trackBy: trackByLineId">
      <div nz-row>
        <div nz-col nzXs="24" nzSm="24" nzMd="24"
          [nzLg]="fieldGroupLayouts[fieldKey]"
          [nzXl]="fieldGroupLayouts[fieldKey]"
          *ngFor="let fieldKey of fieldGroupKeys; trackBy: trackByFieldKey">
          <div *ngFor="let field of fieldGroups[fieldKey]; trackBy: trackByFieldId">
            <app-field [moduleStructure]="moduleStructure" [field]="field" [recordModel]="recordModel" [section]="section"
              [lineId]="selectedLine.Id" [actionType]="actionType"></app-field>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<nz-empty *ngIf="lineCategory.Lines.length === 0" [nzNotFoundFooter]="footerTpl">

</nz-empty>
<ng-template #footerTpl>
  <button *ngIf="this.allowAdd" nz-button nzType="default" (click)="addNewCard()">
    <i nz-icon nzType="plus" nzTheme="outline"></i> {{'Add new' | locale}}
  </button>
</ng-template>
